import React from "react";
import PropTypes from "prop-types";
import Column from "./Column";
import {Date as DateDisplay, DateTime as DateTimeDisplay, Time as TimeDisplay} from "@morningtrain/react-displays";

function DateTimeColumn(props) {

    let Display = DateTimeDisplay;

    if (props.time === false) {
        Display = DateDisplay;
    }

    if (props.date === false) {
        Display = TimeDisplay;
    }

    return <Column {...props} display={Display}/>;
}

DateTimeColumn.defaultProps = {
    ...Column.defaultProps,
    date: true,
    time: true,
};

DateTimeColumn.propTypes = {
    ...Column.propTypes,
    date: PropTypes.bool,
    time: PropTypes.bool,
};

export default DateTimeColumn;
